/** Backend API origin. Empty = webpack dev-server proxy to localhost:8001. */
export const API_BASE: string = process.env.BACKEND_URL || '';

/** Phone pay app origin — QR codes must point here, not the display device. */
export const ADHOC_MOBILE_URL: string = process.env.ADHOC_MOBILE_URL || '';
